// src/config/api-config.js
import awsconfig from '../aws-exports';

// Legacy SAM backend API (old endpoints)
const SAM_API_URL = 'https://5nhwh9wpoj.execute-api.us-east-1.amazonaws.com/Prod';

// New Amplify API (migrated endpoints)
const amplifyApi = awsconfig.aws_cloud_logic_custom?.[0];
const AMPLIFY_API_URL = amplifyApi?.endpoint || 'https://faaprm09i7.execute-api.us-east-1.amazonaws.com/dev';

// Map of endpoints that have been migrated to Amplify
const AMPLIFY_ENDPOINTS = [
  '/validate-coupon',
  '/add-payment-method',
  '/create-subscription',
  '/get-payment-methods',
  '/remove-payment-method',
  '/update-default-payment-method',
  '/cancel-subscription',
  '/resume-subscription',
  '/get-user-billing-info',
  '/transcribe-episode',
  '/getPodcastFeed',
  '/getPodcastFeeds',
  '/addPodcastFeed',
  '/getEpisode',
  '/getEpisodes',
  '/getAllEpisodes',
  '/getSocialPosts',
  '/getAllSocialPosts',
  '/newEpisode',
  '/updateFeedPreference',
  '/updateCustomPrompt',
  '/getDefaultPrompts',
  '/getCustomPrompts',
  '/connections/status',
  '/updateSocialPost',
  '/regenerateSocialPost',
  '/facebook/auth',
  '/instagram/auth',
  '/linkedin/auth',
  '/x/auth',
  '/facebook/select-page',
  '/facebook/get-temp-token',
  '/disconnect-social-media',
  '/getPlatformPreferences',
  '/updatePlatformPreferences'
];

// Helper function to determine which API to use
export const getApiUrl = (endpoint) => {
  const isAmplifyEndpoint = AMPLIFY_ENDPOINTS.some(path => endpoint.startsWith(path));
  return isAmplifyEndpoint ? AMPLIFY_API_URL : SAM_API_URL;
};

// Export the Amplify URL as default (all auth endpoints are now on Amplify)
export default AMPLIFY_API_URL;

export { AMPLIFY_API_URL, SAM_API_URL };